import {
	getMailCategoryReport,
	getPromotionReport,
} from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';
import { MAIL_TYPES } from '../constants/mailTypes';

const useMailReport = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const [displayedRows, setDisplayedRows] = useState();

	const isLoading =
		hasUnfilledRequest(getMailCategoryReport) ||
		hasUnfilledRequest(getPromotionReport);

	const getTypedResponse = ({ dateFrom, dateTo, mailNameIds, mailingType }) => {
		switch (mailingType) {
			case MAIL_TYPES.PROMOTION: {
				const payload = { dateFrom, dateTo, promotionIds: mailNameIds };
				return makeRequest(getPromotionReport.bind(null, payload));
			}
			default: {
				const payload = { dateFrom, dateTo, mailCategoriesIds: mailNameIds };
				return makeRequest(getMailCategoryReport.bind(null, payload));
			}
		}
	};

	const fetchMailTemplateStats = async (params) => {
		const response = await getTypedResponse(params);

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		setDisplayedRows(response.data);
	};

	return {
		displayedRows,
		setDisplayedRows,
		fetchMailTemplateStats,
		isLoading,
	};
};

export default useMailReport;
